import { Injectable } from '@angular/core';
import { HttpService } from '@symphony-solo/shared/http/src';
import { Observable } from 'rxjs';
import { LocationResponse } from '../models';

@Injectable()
export class LocationService {
  private path = 'location';
  constructor(private httpService: HttpService) {}

  public authenticateLocation(locationGuid: string): Observable<LocationResponse> {
    return this.httpService.makeGet<LocationResponse>(`${this.path}/${locationGuid}`);
  }
}
